const socialHandleUrls = {
  linkedin: "https://www.linkedin.com/company/jobsurance",
  instagram: "https://www.instagram.com/jobsurance/",
  youtube: "https://www.youtube.com/@Jobsurance",
};

export default socialHandleUrls;
